import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { PageTitle } from 'main/components/_common/BasePage/PageTitle';
import { selectUserRole } from 'main/store/common/selectors';
import { useNavigate } from 'react-router-dom';

export const AdministratorManagementPage = () => {
    const navigate = useNavigate();
    const userRole = useSelector(selectUserRole);

    useEffect(() => {
        if (userRole !== 'administrator') {
            navigate('/membemr-only');
        }
    }, [userRole, navigate]);

    return (
        <Grid container direction="column" height="100%">
            <Grid item>
                <PageTitle>管理者管理</PageTitle>
            </Grid>
            <Grid item>

            </Grid>
        </Grid>
    )
}
